{
  "login": {
    "genericError": "Une erreur s'est produite lors de la connexion. Veuillez réessayer."
  },
  "acceptTerms": {
    "pleaseAccept": "Veuillez accepter les conditions générales d'utilisation pour continuer",
    "accepted": "Conditions générales d'utilisation acceptées",
    "failedGeneric": "Échec de l'acceptation des conditions. Veuillez réessayer."
  },
  "discord": {
    "linkSuccess": "Compte Discord lié ! Veuillez vérifier vos DMs ci-dessous.",
    "linkFailed": "Échec de la liaison du compte Discord : {{message}}",
    "verificationSent": "Code de vérification envoyé dans vos DMs Discord !",
    "dmVerified": "DMs Discord vérifiés avec succès ! Les notifications sont maintenant disponibles.",
    "settingToggled": "{{label}} {{state}}",
    "unlinked": "Compte Discord dissocié avec succès !",
    "userIdNotFound": "ID utilisateur introuvable. Veuillez vous reconnecter.",
    "clientIdNotConfigured": "ID client Discord non configuré. Vérifiez vos variables d'environnement.",
    "redirectUriNotConfigured": "URL de redirection mal configurée. Vérifiez vos variables d'environnement.",
    "allowPopups": "Veuillez autoriser les popups pour ce site afin de lier votre compte Discord",
    "linkFirst": "Veuillez d'abord lier votre compte Discord",
    "sendCodeFailed": "Échec de l'envoi du code de vérification. Assurez-vous que le bot peut vous envoyer des DMs.",
    "sendCodeFailedGeneric": "Échec de l'envoi du code de vérification",
    "enterCode": "Veuillez entrer le code de vérification",
    "verifyCodeFailed": "Échec de la vérification du code. Veuillez réessayer.",
    "verifyFirst": "Veuillez d'abord vérifier vos DMs Discord",
    "updateSettingFailed": "Échec de la mise à jour des paramètres de notification",
    "unlinkFailed": "Échec de la dissociation du compte Discord",
    "categoryUpdated": "Catégorie mise à jour",
    "categoryUpdateFailed": "Impossible de mettre à jour la catégorie",
    "categoryDeleted": "Catégorie supprimée",
    "categoryDeleteFailed": "Impossible de supprimer la catégorie",
    "defaultCategoryUpdated": "Catégorie par défaut mise à jour",
    "setDefaultFailed": "Impossible de définir la catégorie par défaut",
    "categoryCreated": "Catégorie créée",
    "categoryCreateFailed": "Impossible de créer la catégorie"
  },
  "subscription": {
    "failedLoadPricing": "Échec du chargement des informations tarifaires",
    "failedCheckout": "Échec du lancement du paiement",
    "failedChangeSubscription": "Échec du changement d'abonnement",
    "failedOpenBillingPortal": "Échec de l'ouverture du portail de facturation",
    "cancelSuccess": "Votre abonnement a été annulé avec succès",
    "cancelFailed": "Échec de l'annulation de l'abonnement",
    "resumeSuccess": "Votre abonnement a été repris avec succès",
    "resumeFailed": "Échec de la reprise de l'abonnement",
    "updateSuccess": "Votre abonnement a été mis à jour !",
    "newSubscriptionSuccess": "Bienvenue ! Votre abonnement est maintenant actif."
  },
  "trial": {
    "activated": "Essai activé ! Profitez de 7 jours de FlippingPal.",
    "activationFailed": "Échec de l'activation de l'essai"
  },
  "account": {
    "emailBothFieldsRequired": "Veuillez remplir les deux champs",
    "emailInvalid": "Veuillez entrer une adresse e-mail valide",
    "emailUpdated": "E-mail mis à jour ! Veuillez vérifier votre nouvel e-mail pour confirmer. Déconnexion...",
    "emailFailed": "Échec du changement d'e-mail",
    "passwordAllFieldsRequired": "Veuillez remplir tous les champs de mot de passe",
    "passwordTooShort": "Le nouveau mot de passe doit comporter au moins 4 caractères",
    "passwordsDoNotMatch": "Les nouveaux mots de passe ne correspondent pas",
    "passwordChanged": "Mot de passe changé avec succès !",
    "passwordFailed": "Échec du changement de mot de passe",
    "closeAccountPasswordRequired": "Veuillez entrer votre mot de passe",
    "closeAccountConfirmRequired": "Veuillez taper \"FERMER MON COMPTE\" pour confirmer",
    "accountClosed": "Compte fermé. Déconnexion...",
    "closeAccountFailed": "Échec de la fermeture du compte"
  },
  "snipe": {
    "ilvlEnterAtLeastOne": "Veuillez entrer au moins un ilvl min ou max",
    "ilvlValidMin": "Veuillez entrer un ilvl min valide",
    "ilvlValidMax": "Veuillez entrer un ilvl max valide",
    "ilvlMinExceedsMax": "L'ilvl min ne peut pas dépasser {{max}}",
    "ilvlMaxExceedsMax": "L'ilvl max ne peut pas dépasser {{max}}",
    "ilvlMinGreaterThanMax": "L'ilvl min ne peut pas être supérieur à l'ilvl max",
    "ilvlValidPrice": "Veuillez entrer un prix valide (ex. 100g, 50g 30s, ou 100)",
    "reqLvlMinRange": "Le niveau min requis doit être entre {{min}} et {{max}}",
    "reqLvlMaxRange": "Le niveau max requis doit être entre {{min}} et {{max}}",
    "reqLvlMinGreaterThanMax": "Le niveau min requis ne peut pas être supérieur au niveau max requis",
    "ilvlAdded": "Snipe ilvl ajouté",
    "ilvlUpdated": "Snipe ilvl mis à jour",
    "ilvlSaveFailed": "Échec de l'enregistrement du snipe ilvl",
    "ilvlRemoved": "Snipe ilvl supprimé",
    "ilvlRemoveFailed": "Échec de la suppression du snipe ilvl",
    "selectItem": "Veuillez sélectionner un objet",
    "validPetId": "Veuillez entrer un ID de familier valide ou rechercher un familier",
    "invalidPrice": "Veuillez entrer un prix valide (ex. 100g, 50g 30s, ou 100)",
    "itemAdded": "Snipe {{label}} ajouté",
    "itemUpdated": "Snipe {{label}} mis à jour",
    "itemAddFailed": "Échec de l'ajout du snipe {{type}}",
    "itemRemoved": "Snipe {{type}} supprimé",
    "itemRemoveFailed": "Échec de la suppression du snipe {{type}}",
    "editingWoWToken": "Modification de l'alerte snipe WoW Token",
    "editingSnipeAlert": "Modification de l'alerte snipe pour {{name}}",
    "itemNotFound": "{{label}} introuvable.",
    "importInvalidArrayFormat": "Format invalide. Un tableau de règles snipe ilvl est attendu.",
    "importNoValidEntries": "Aucune entrée valide trouvée. Les éléments du tableau ont besoin des champs \"{{idKey}}\" et \"price\".",
    "importInvalidJsonFormat": "Format JSON invalide. Attendu { {{idKey}}: goldPrice, ... } ou un tableau d'objets.",
    "importSuccess": "Import : {{added}} ajouté(s), {{updated}} mis à jour, {{skipped}} ignoré(s)",
    "importIlvlSuccess": "{{count}} règle(s) snipe ilvl importée(s)",
    "importParseFailed": "Échec de l'analyse ou de l'importation du JSON",
    "noItemsToExport": "Aucun {{type}} à exporter",
    "noIlvlItemsToExport": "Aucun objet ilvl à exporter",
    "exportSuccess": "{{count}} {{type}} exporté(s)",
    "exportIlvlSuccess": "{{count}} objet(s) ilvl exporté(s)",
    "enabledToggle": "Alertes snipe {{state}}",
    "enabledToggleFailed": "Échec de la mise à jour du paramètre snipe",
    "alertStyleUpdated": "Style d'alerte défini sur {{style}}",
    "alertStyleFailed": "Échec de la mise à jour du style d'alerte",
    "realmsSaved": "Royaumes snipe enregistrés",
    "realmsSaveFailed": "Échec de l'enregistrement des royaumes snipe",
    "clearAllConfirm": "Êtes-vous sûr de vouloir supprimer tous les snipes {{label}} ?",
    "clearAllSuccess": "Tous les snipes {{label}} effacés",
    "clearAllFailed": "Échec de l'effacement des snipes {{label}}",
    "cooldownCyclesUpdated": "Délai d'alerte défini à {{cycles}} cycle(s) ignoré(s)",
    "cooldownCyclesFailed": "Échec de la mise à jour du délai d'alerte",
    "cooldownCyclesInvalid": "Le délai doit être compris entre 0 et 24 cycles",
    "undo": "Rétablir",
    "undoRestored": "Alerte de snipe restaurée",
    "undoFailed": "Impossible de restaurer l'alerte de snipe",
    "priceUpdated": "Prix mis à jour",
    "priceUpdateFailed": "Impossible de mettre à jour le prix"
  },
  "personalConfig": {
    "saveSuccess": "Valeurs par défaut des filtres enregistrées avec succès !",
    "saveFailed": "Échec de l'enregistrement des valeurs par défaut des filtres"
  },
  "auth": {
    "registrationSuccessEmail": "Inscription réussie ! Veuillez vérifier votre e-mail pour confirmation.",
    "registrationSuccessLogin": "Inscription réussie ! Veuillez vous connecter avec votre nouveau compte.",
    "passwordResetSuccess": "Mot de passe réinitialisé avec succès"
  },
  "common": {
    "networkError": "Erreur réseau. Veuillez réessayer."
  },
  "validation": {
    "passwordRequired": "Le mot de passe est requis",
    "passwordMinLength": "Le mot de passe doit contenir au moins {{count}} caractères",
    "passwordUppercase": "Le mot de passe doit contenir au moins une lettre majuscule",
    "passwordLowercase": "Le mot de passe doit contenir au moins une lettre minuscule",
    "passwordNumber": "Le mot de passe doit contenir au moins un chiffre",
    "passwordSpecialChar": "Le mot de passe doit contenir au moins un caractère spécial",
    "confirmPasswordRequired": "Veuillez confirmer votre mot de passe",
    "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
    "emailRequired": "L'e-mail est requis",
    "emailInvalid": "Veuillez entrer une adresse e-mail valide"
  },
  "filterPreset": {
    "fetchFailed": "Échec du chargement des préréglages de filtres",
    "createFailed": "Échec de la création du préréglage de filtre",
    "updateFailed": "Échec de la mise à jour du préréglage de filtre",
    "deleteFailed": "Échec de la suppression du préréglage de filtre",
    "invalidImportNotObject": "Chaîne d'importation invalide : pas un objet de préréglage valide",
    "invalidImportMissingVersion": "Chaîne d'importation invalide : informations de version manquantes",
    "invalidImportMissingPreset": "Chaîne d'importation invalide : données de préréglage manquantes",
    "invalidPresetMissingName": "Préréglage invalide : nom manquant ou invalide",
    "invalidPresetMissingFilters": "Préréglage invalide \"{{name}}\" : filtres manquants ou invalides"
  }
}
